<div class="component-viewer">
    <div class="leagues-container">
        <!-- Left side: Leagues List -->
        <div class="leagues-list" [class.has-panel]="selectedLeague">
            <mat-card>
                <mat-card-header style="display: inline;">
                    <div class="row w-100">
                        <div class="col-6 text-start">
                            <h2 class="mb-0">Leagues</h2>
                        </div>
                        <div class="col-6 text-end">
                            <button mat-raised-button (click)="onCreate()">
                                Add <mat-icon>add</mat-icon>
                            </button>
                        </div>
                    </div>
                </mat-card-header>
                <mat-card-content>
                    <gt-table *ngIf="true" [loading]="isLoading" [defaultPageSize]="10" [updateFilterEvent]="updateFilterEvent"
                        [filter]="filter" [data]="leagues" (filterChanged)="getLeagues()" [placeholder]="'Search by league name'">
                    </gt-table>
                    <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>
                    <table mat-table [dataSource]="leagues" matSort (matSortChange)="sortData($event)">
                        <ng-container matColumnDef="name">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header="name"> Name </th>
                            <td mat-cell *matCellDef="let league"> {{league.name}} </td>
                        </ng-container>
                        <ng-container matColumnDef="description">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header="description"> Description </th>
                            <td mat-cell *matCellDef="let league"> {{league.description}} </td>
                        </ng-container>
                        <ng-container matColumnDef="iterationCount">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header="iterationCount"> Iterations </th>
                            <td mat-cell *matCellDef="let league"> {{league.iterationCount || 0}} </td>
                        </ng-container>
                        <ng-container matColumnDef="memberCount">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header="memberCount"> Members </th>
                            <td mat-cell *matCellDef="let league"> {{league.memberCount || 0}} </td>
                        </ng-container>
                        <ng-container matColumnDef="actions">
                            <th mat-header-cell *matHeaderCellDef> Actions </th>
                            <td mat-cell *matCellDef="let league">
                                <button mat-icon-button [matMenuTriggerFor]="actionsMenu">
                                    <mat-icon>more_vert</mat-icon>
                                </button>
                                <mat-menu #actionsMenu>
                                    <button mat-menu-item (click)="onViewIterations(league)">
                                        <mat-icon>calendar_today</mat-icon>
                                        <span>Manage Iterations</span>
                                    </button>
                                    <mat-divider></mat-divider>
                                    <button mat-menu-item (click)="onEdit(league)">
                                        <mat-icon>edit</mat-icon>
                                        <span>Edit</span>
                                    </button>
                                    <button mat-menu-item (click)="onDelete(league)">
                                        <mat-icon>delete</mat-icon>
                                        <span>Delete</span>
                                    </button>
                                </mat-menu>
                            </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    </table>
                </mat-card-content>
            </mat-card>
        </div>

        <!-- Right side: Iterations Panel -->
        <div class="iterations-panel" *ngIf="selectedLeague" [@slideIn]>
            <mat-card>
                <mat-card-content>
                    <league-iterations-list 
                        [league]="selectedLeague"
                        (iterationsUpdated)="onIterationsUpdated()"
                        (onCloseIterationsPanel)="onCloseIterationsPanel()">
                    </league-iterations-list>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
</div>

